import React from 'react'
import styles from './SectionContainer.module.scss'
import { SectionContainerProps } from './SectionContainer.types'
import cl from 'classnames'

const SectionContainerComponent = (props: SectionContainerProps) => {
  const { children, className, label, innerTitle, style } = props

  return (
    <div className={cl(styles.container)} style={style}>
      {label && <h3>{label}</h3>}

      <div
        className={cl(styles.body, className, {
          [styles.paddingTop]: innerTitle
        })}
      >
        {innerTitle && <h4>{innerTitle}</h4>}
        {children}
      </div>
    </div>
  )
}

const SectionContainer = SectionContainerComponent
export { SectionContainer }
